import { footerSections, socialLinks } from "@/data/footerLinks";
import Link from "next/link";
export default function Footer3() {
  return (
    <>
      {/* Start Footer Area  */}
      <footer className="rainbow-footer footer-style-default variation-two">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              {footerSections.map((section, index) => (
                <div className="col-lg-2 col-md-6 col-sm-6 col-12" key={index}>
                  <div className="rainbow-footer-widget">
                    <h4 className="title">{section.title}</h4>
                    <div className="inner">
                      <ul className="footer-link link-hover">
                        {section.links.map((link, i) => (
                          <li key={i}>
                            <Link href={link.href}>{link.label}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="rainbow-footer-widget">
                  <h4 className="title">Følg oss!</h4>
                  <div className="inner">
                    <h6 className="subtitle">
                      Besøk vår Facebook og LinkedIn
                    </h6>
                    <ul className="social-icon social-default justify-content-start">
                      {socialLinks.map((link, index) => (
                        <li key={index}>
                          <a href={link.href}>
                            <i className={link.iconClass} />
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div style={{ paddingTop: '20px' }}>
                  <p>
                    © SB Tech AS {new Date().getFullYear()}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* End Footer Area  */}
    </>
  );
}
